import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

// Section components
import { HeroSection } from './components/hero-section/hero-section';
import { ProcessSection } from './components/process-section/process-section';
import { StyleSection } from './components/style-section/style-section';
import { CreateSection } from './components/create-section/create-section';
import { FaqSection } from './components/faq-section/faq-section';
import { InspireSection } from './components/inspire-section/inspire-section';
import { ProductsSection } from './components/products-section/products-section';
import { TestimonialsSection } from './components/testimonials-section/testimonials-section';

@Component({
  selector: 'app-landing-page',
  imports: [
    CommonModule,
    // Section components
    HeroSection,
    ProcessSection,
    StyleSection,
    CreateSection,
    FaqSection,
    InspireSection,
    ProductsSection,
    TestimonialsSection
  ],
  templateUrl: './home.page.html',
  styleUrl: './home.page.scss'
})
export class HomePage {
}
